import { computed } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'

export default {
  name: 'index',
  props: {
    geozone: Object,
  },
  setup(props, context) {
    const { $store } = context.root
    const { makeRequest } = useRequest({
      context,
      request: () => $store.dispatch('geozone/deleteGeozone', { id: props.geozone.id }),
      successMessage: 'Геозона успешно удалена.',
    })

    const icon = computed(() => {
      const polygonIcon = require('@/assets/icons/geozone/poligon.svg')
      const circleIcon = require('@/assets/icons/geozone/circle.svg')
      if (props.geozone.geozoneType === 'circle') return circleIcon
      return polygonIcon
    })

    const { $router } = context.root
    const navigate = () => $router.push(`/personal/geozones/view/${props.geozone.id}`)
    const remove = async () => {
      // eslint-disable-next-line no-restricted-globals
      if (!confirm('Вы уверены?')) return
      await makeRequest()
      context.emit('update')
    }

    return {
      icon,
      navigate,
      remove,
    }
  },
}
